import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';

import Content from '../components/layout/Content';
import Loading from '../components/Loading';

class Tablets extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { tablets, intl } = this.props;

    const tabletsNameText = intl.formatMessage({ id: 'tablet.name' });
    const macAddressText = intl.formatMessage({ id: 'macaddress' });
    const ipText = intl.formatMessage({ id: 'ip' });
    const screenResolutionText = intl.formatMessage({ id: 'screenresolution' });
    const statusText = intl.formatMessage({ id: 'status' });
    const actionsText = intl.formatMessage({ id: 'actions' });

    return (
      <Content title="Tablets">
        {
          !tablets ? <Loading />
            : (
              <ReactTable
                data={tablets}
                columns={[
                  {
                    columns: [
                      {
                        Header: tabletsNameText,
                        accessor: 'displayName',
                      },
                      {
                        Header: macAddressText,
                        accessor: 'macAddress',
                      },
                      {
                        Header: ipText,
                        accessor: 'ipAddress',
                        maxWidth: 150,
                      },
                      {
                        Header: screenResolutionText,
                        accessor: 'screenResolution',
                      },
                      {
                        Header: statusText,
                        id: 'status',
                        accessor: (data) => <Cricle active={data.isActive} />,
                        maxWidth: 150,
                      },
                      {
                        Header: actionsText,
                        id: 'actions',
                        accessor: (data) => <Link to={`/panel/tablet/${data.id}`}>Detail</Link>,
                        maxWidth: 150,
                      },
                    ],
                  },
                ]}
                defaultPageSize={10}
                className="table"
              />
            )
        }
      </Content>
    );
  }
}

Tablets.propTypes = {
  intl: intlShape.isRequired,
  tablets: PropTypes.array.isRequired,
};

const Cricle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? 'green' : 'red')};
`;

const mapStateToProps = (state, dispatch) => ({
  user: state.auth.user,
  tablets: state.tablets,
  dispatch,
});

export default injectIntl(connect(mapStateToProps)(Tablets));
